export default function addThousandsSeparators(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
